import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Routers from "../routes/Router";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { FetchSubAdminsDetails } from "../features/subAdmin/SubAdminSlice";
import { setTeacherName } from "../app/globalStore";
import { FetchCompanySettings } from "../features/slice";
import { FetchCompanyList } from "../features/company/CompanySlice";
import { toast } from 'react-toastify';
import SubscriptionPlansModal from "./SubscriptionPlansModal";
import OnboardingModal from "./OnboardingModal";
import OnboardingCompleteModal from "./OnboardingCompleteModal";
import { getCompanySubscription } from '../api/subscription';
import { startFreeTrial } from '../api';

function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const mainAdminId = useSelector((store) => store.main.id);
  const authState = useSelector((store) => store.auth);
  const authAdminId = authState?.adminId;
  const id = mainAdminId || authAdminId;
  const data = useSelector((store) => store.subAdmin.detail);
  const companySettings = useSelector((store) => store.main.companySettings);
  const profileCompletionData = useSelector((store) => store.main.profileCompletionData);
  const resolvedAdminType = (data?.admin_type || authState?.admin_type || "")?.toLowerCase();
  const rawModules = data?.modules || authState?.modules || {};
  const resolvedModules = { ...rawModules };
  if (resolvedModules.newsletter !== undefined) {
    resolvedModules["communication-template"] = resolvedModules.newsletter;
    delete resolvedModules.newsletter;
  }
  const resolvedIsCompany = data?.is_company ?? (authState?.user_type === "company" || authState?.user_type === "teacher");
  const resolvedIsTeacher = data?.is_teacher ?? (authState?.user_type === "teacher" ? 1 : 0);
  const resolvedName = data?.name || authState?.name;
  const isPlatformSuperAdmin =
    authState?.user_type?.toLowerCase() === "super_admin";

  if (resolvedName) {
    setTeacherName(resolvedName);
  }
  async function logout(e) {
    await localStorage.clear();
    // Clear all pagination state from sessionStorage on logout
    sessionStorage.clear();
    navigate("/");
  }

  // Clear sessionStorage when navigating from sidebar
  const handleSidebarNavigation = () => {
    // Clear all filter and pagination states from sessionStorage
    sessionStorage.clear();
  };

  const [openMenu, setOpenMenu] = useState(null);
  const [openSubMenu, setOpenSubMenu] = useState({});
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [showOnboardingModal, setShowOnboardingModal] = useState(false);
  const [showOnboardingCompleteModal, setShowOnboardingCompleteModal] = useState(false);
  const [companySubscription, setCompanySubscription] = useState(null);
  const [loadingSubscription, setLoadingSubscription] = useState(false);
  const [isBlinking, setIsBlinking] = useState(false);

  const toggleMenu = (index) => {
    setOpenMenu(openMenu === index ? null : index);
  };

  const toggleSubMenu = (key) => {
    setOpenSubMenu((prev) => ({
      ...prev,
      [key]: !prev?.[key]
    }));
  };

  // const [data, setData] = useState({});

  useEffect(() => {
    if (id) {
      dispatch(FetchSubAdminsDetails(id)).then((res) => {
        const userDetails = res?.payload?.data?.user_details;
        // Only fetch company list for super admins (not company admins)
        if (!userDetails?.is_company) {
          dispatch(FetchCompanyList({ page: 1, limit: 1000000 })).then((companyRes) => {
            if (companyRes?.payload?.code === 1 && companyRes?.payload?.data?.company_list) {
              localStorage.setItem(
                "companies",
                JSON.stringify(companyRes.payload.data.company_list)
              );
            }
          });
        }else{
           localStorage.removeItem("companies");
        }
      });
      dispatch(FetchCompanySettings());
      
    }
  }, [dispatch, id]);

  useEffect(()=>{
    localStorage.setItem('booking_fee',companySettings?.booking_fee)
  },[companySettings])
  
  // Fetch company subscription data
  useEffect(() => {
    if (resolvedIsCompany && id) {
      fetchCompanySubscription();
    }
  }, [resolvedIsCompany, id]);

  // Auto-show onboarding complete modal for companies without trial and no subscription
  useEffect(() => {
    // Only check after API call is complete (loadingSubscription is false)
    // And only if subscription data exists (not null)
    // Check if modal has been dismissed in this session
    const completeModalDismissed = localStorage.getItem('onboardingCompleteModalDismissed');
    if (resolvedIsCompany && !loadingSubscription && companySubscription !== null) {
      // Only show if profile is complete (is_profile_complete == 1 or is_basic_profile_complete == true)
      if (data?.is_profile_complete == 1) {
        // Check if company has no trial and no subscription
        if (!isInTrialPeriod() && !hasActiveSubscription()) { 
          console.log('Sidebar: Showing onboarding complete modal - profile complete, no trial and no subscription');
          setShowOnboardingCompleteModal(true);
        } else {
          console.log('Sidebar: Not showing modal - profile complete but active subscription or in trial');
          setShowOnboardingCompleteModal(false);
        }
      } else {
        console.log('Sidebar: Not showing modal - profile not complete');
        setShowOnboardingCompleteModal(false);
      }
    }
  }, [resolvedIsCompany, loadingSubscription, companySubscription, data?.trial_end, data?.is_profile_complete, data?.is_basic_profile_complete]);

  // Blinking effect for incomplete profile
  useEffect(() => {
    if (resolvedIsCompany && !resolvedIsTeacher && data?.is_profile_complete == 0) {
      const interval = setInterval(() => {
        setIsBlinking(prev => !prev);
      }, 500);
      return () => clearInterval(interval);
    } else {
      setIsBlinking(false);
    }
  }, [resolvedIsCompany, resolvedIsTeacher, data?.is_profile_complete]);

  // Show onboarding modal on listing pages after company profile is saved
  useEffect(() => {
    const currentPath = location.pathname;
    
    // Listing pages where modal should show
    const listingPages = [
      '/dashboard',
      '/teacher',
      '/area-code',
      '/school',
      '/discipline',
      '/consents',
      '/company-terms-and-conditions'
    ];
    
    // Add/edit pages where modal should NOT show
    const isAddOrEditPage = currentPath.includes('/add') || currentPath.includes('/edit');
    
    // Check if current path is a listing page
    const isListingPage = listingPages.some(page => currentPath.startsWith(page));
    
    console.log('Onboarding modal check:', {
      resolvedIsCompany,
      resolvedIsTeacher,
      is_profile_complete: data?.is_profile_complete,
      is_basic_profile_complete: data?.is_basic_profile_complete,
      currentPath,
      isListingPage,
      isAddOrEditPage,
      modalDismissed: localStorage.getItem('onboardingModalDismissed'),
      shouldShow: resolvedIsCompany && !resolvedIsTeacher && isListingPage && !isAddOrEditPage
    });
    
    // Clear dismissed flag when navigating to listing pages to allow showing modal again
    if (isListingPage && !isAddOrEditPage) {
      localStorage.removeItem('onboardingModalDismissed');
    }
    
    // Check if modal has been dismissed in this session
    const modalDismissed = localStorage.getItem('onboardingModalDismissed');
    
    // Check if profile was just completed and onboarding modal should be shown
    const showOnboardingAfterProfileComplete = localStorage.getItem('showOnboardingAfterProfileComplete');
    
    // Show modal if:
    // - User is company (not teacher)
    // - Company profile is NOT complete (basic profile incomplete and profile incomplete)
    // - Current page is a listing page
    // - Not on add/edit page
    // - Modal not dismissed
    // OR profile was just completed and we want to show the onboarding modal
    if (resolvedIsCompany && !resolvedIsTeacher && 
        isListingPage && !isAddOrEditPage &&
        !modalDismissed &&
        (!(data?.is_profile_complete == 1) || showOnboardingAfterProfileComplete === 'true')) {
      // Delay showing modal to ensure data is loaded
      const timer = setTimeout(() => {
        console.log('Showing onboarding modal on listing page');
        setShowOnboardingModal(true);
        localStorage.removeItem('showOnboardingAfterProfileComplete');
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [resolvedIsCompany, resolvedIsTeacher, data?.is_profile_complete, data?.is_basic_profile_complete, location.pathname]);

  // Check if company has active subscription
  const hasActiveSubscription = () => {
    // If in trial period, consider subscription active
    if (isInTrialPeriod()) return true;
    
    if (!companySubscription) return false;
    
    // Handle different possible status values
    const status = companySubscription.status?.toString().toLowerCase();
    
    // Consider subscription active if status is one of these values
    const activeStatuses = ['active', '1', 1, 'paid', 'subscribed', 'enabled', 'trial', 'trialing'];
    return activeStatuses.includes(status);
  };

  // Check if company is within trial period
  const isInTrialPeriod = () => {
    if (!data?.trial_end) return false;
    const trialEndDate = new Date(data.trial_end);
    const currentDate = new Date();
    return currentDate <= trialEndDate;
  };

  // Calculate remaining trial days
  const calculateTrialDaysLeft = () => {
    if (!data?.trial_end) return null;
    const now = new Date();
    const trialEnd = new Date(data.trial_end);
    const daysLeft = Math.ceil((trialEnd - now) / (1000 * 60 * 60 * 24));
    return daysLeft >= 0 ? daysLeft : 0;
  };

  const fetchCompanySubscription = async () => {
    setLoadingSubscription(true);
    try {
      const companyId = authState?.company_id || data?.company_id;
      if (companyId) {
        const response = await getCompanySubscription(companyId);
        console.log('Sidebar - Subscription API Response:', response); // Debug log
        
        if (response?.code === 1 && response?.data) {
          console.log('Sidebar - Subscription data:', response.data); // Debug log
          setCompanySubscription(response.data);
        } else {
          console.log('Sidebar - No subscription data found:', response); // Debug log
          setCompanySubscription(null);
        }
      }
    } catch (error) {
      console.error('Sidebar - Error fetching company subscription:', error);
      setCompanySubscription(null);
    } finally {
      setLoadingSubscription(false);
    }
  };

  const handleSubscriptionClick = () => {
    // Check if trial has expired (trial_end exists but is in the past)
    const trialEndDate = data?.trial_end ? new Date(data.trial_end) : null;
    const currentDate = new Date();
    const isTrialExpired = trialEndDate && currentDate > trialEndDate;

    // If trial has expired and no active subscription, show Subscription Plans Modal
    if (isTrialExpired && !hasActiveSubscription()) {
      setShowSubscriptionModal(true);
    }
    // If company has no trial and no subscription, show Onboarding Complete Modal
    else if (!isInTrialPeriod() && !hasActiveSubscription() && !trialEndDate) {
      setShowOnboardingCompleteModal(true);
    }
    // If company has trial (not expired), show Onboarding Complete Modal with trial info
    else if (isInTrialPeriod()) {
      setShowOnboardingCompleteModal(true);
    }
    // If company has subscription, show Subscription Plans Modal
    else if (companySubscription) {
      setShowSubscriptionModal(true);
    }
    // Default: show Subscription Plans Modal
    else {
      setShowSubscriptionModal(true);
    }
  };

  const handleStartTrial = async () => {
    const companyId = authState?.company_id || data?.company_id;
    if (companyId) {
      await startFreeTrial(companyId);
      // Refresh subscription data after starting trial
      await fetchCompanySubscription();
      // Refresh page to update trial status
      window.location.reload();
    }
  };

  const handlePurchaseSubscription = () => {
    setShowOnboardingCompleteModal(false);
    setShowSubscriptionModal(true);
  };

  const handleOnboardingModalClose = () => {
    localStorage.setItem('onboardingModalDismissed', 'true');
    setShowOnboardingModal(false);
  };

  const handleOnboardingCompleteModalClose = () => {
    localStorage.setItem('onboardingCompleteModalDismissed', 'true');
    setShowOnboardingCompleteModal(false);
  };

  // Helper function to check if company has no trial and no subscription
  // Super admins (non-company users) always bypass subscription checks
  const hasNoTrialAndNoSubscription = () => {
    if (!resolvedIsCompany) return false;
    return !isInTrialPeriod() && !hasActiveSubscription();
  };

  // Helper function to check if menu item should be visible for incomplete company profiles
  const isMenuItemVisibleForIncompleteProfile = (menu) => {
    // Trial users have access to all menus
    if (isInTrialPeriod()) {
      return true;
    }

    // If profile is complete and has trial or subscription, show all menus
    if ((data?.is_profile_complete == 1 || !resolvedIsCompany || resolvedIsTeacher) && !hasNoTrialAndNoSubscription()) {
      return true;
    }

    // For incomplete profiles or no trial/subscription, hide dashboard and only show specific menus
    if (menu.subname === 'dashboard') {
      return false;
    }

    // Only show specific menus for incomplete profiles or no trial/subscription
    const allowedMenus = ['class', 'teacher']; // Organisation Setup and Team
    return allowedMenus.includes(menu.subname);
  };

  // Helper function to filter subElements for incomplete profiles
  const filterSubElementsForIncompleteProfile = (subElements, menuSubname) => {
    // Trial users have access to all subElements
    if (isInTrialPeriod()) {
      return subElements;
    }

    // If profile is complete and has trial or subscription, return all subElements
    if ((data?.is_profile_complete == 1 || !resolvedIsCompany || resolvedIsTeacher) && !hasNoTrialAndNoSubscription()) {
      return subElements;
    }

    // For incomplete profiles or no trial/subscription, only show specific subElements for Organisation Setup
    if (menuSubname === 'class') {
      const allowedSubElements = ['area', 'venue', 'discipline', 'consents', 'company_terms'];
      return subElements.filter(sub => allowedSubElements.includes(sub.subname));
    }

    // For Team menu, show Teachers but hide Sub Admin
    if (menuSubname === 'teacher') {
      return subElements.filter(sub => sub.subname === 'teacher');
    }

    return [];
  };

  // Helper function to check if menu item is locked based on company settings
  // Returns object: { locked: boolean, reason: 'admin' | 'company' | 'subscription' | null }
  const isMenuItemLocked = (subElement) => {
    // Super admins have full access - never show locks
    // If is_company is not set or false, user is super admin
    if (!data?.is_company) {
      return { locked: false, reason: null };
    }

    // These menu items should always be accessible even without subscription
    const alwaysAccessibleItems = ['area', 'venue', 'discipline', 'consents', 'company_terms', 'teacher'];
    if (alwaysAccessibleItems.includes(subElement.subname)) {
      return { locked: false, reason: null };
    }
    
    // Check if company has active subscription (includes trial period check) - block all menu items if not
    if (!hasActiveSubscription()) {
      return { locked: true, reason: 'subscription' };
    }
    
    // Check for events menu items
    if (subElement.subname === "events" || subElement.subname === "event_Type") {
      if (companySettings?.admin_events == false) {
        return { locked: true, reason: 'admin' };
      }
      if (companySettings?.events == false) {
        return { locked: true, reason: 'company' };
      }
    }
    // Check for membership settings menu item
    if (subElement.subname === "membership") {
      if (companySettings?.admin_membership == false) {
        return { locked: true, reason: 'admin' };
      }
      if (companySettings?.membership == false) {
        return { locked: true, reason: 'company' };
      }
    }
    
    // Check for finance menu items
    if (subElement.subname === "finance") {
      if (companySettings?.admin_finance == false) {
        return { locked: true, reason: 'admin' };
      }
      if (companySettings?.finance == false) {
        return { locked: true, reason: 'company' };
      }
    }
    
    return { locked: false, reason: null }; // Not locked by default
  };

  // Handle click on locked menu items
  const handleLockedMenuClick = (reason) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (reason === 'admin') {
      toast.warning("This feature is currently disabled. Please contact support to activate this add-on.", { autoClose: false });
    } else if (reason === 'company') {
      toast.warning("You have kept this addon off. Please enable this addon from settings.", { autoClose: false });
    } else if (reason === 'subscription') {
      // Show subscription modal for subscription-related locks
      setShowSubscriptionModal(true);
      toast.warning("Please purchase a subscription to access this feature.", { autoClose: 3000 });
    }
  };

  return (
    <div className="col-lg-4 store-sidebar admin-sidebar" style={{ height: '100vh', overflow: 'hidden' }}>
      <div className="shadow-part" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div className="d-flex flex-column align-items-center">
          <Link
            className="navbar-brand bg-none px-3 mx-lg-auto d-lg-block"
            to="/dashboard"
          >
            <img
              src={resolvedIsCompany ? (data?.image || "assets/images/headerlogo.png") : "assets/images/headerlogo.png"}
              className="img-fluid"
              alt="img"
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = "assets/images/headerlogo.png";
              }}
            />
          </Link>
          {resolvedIsCompany && (
            <div 
              className="d-flex flex-column align-items-center justify-content-center mt-2 px-3"
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(resolvedIsTeacher === 1 ? `/edit-teacher/${data?.id || authState?.teacher_id}` : `/company/edit/${data?.id || authState?.company_id}`)}
            >
              <span 
                className="active"
                style={{ 
                  fontWeight: 'normal',
                  transition: 'color 0.5s ease',
                  color:'#2c58ab'
                }}
              >
                {resolvedName}
              </span>
            </div>
          )}
          {resolvedIsCompany && !resolvedIsTeacher && data?.is_profile_complete == 1 && (
            <button
              className="btn btn-sm btn-outline-primary mt-2"
              style={{ borderRadius: '20px', fontSize: '13px', padding: '4px 16px' }}
              onClick={handleSubscriptionClick}
              disabled={loadingSubscription}
            >
              <i className={`fa ${companySubscription ? 'fa-eye' : 'fa-crown'} me-1`} style={{ fontSize: '12px' }}></i>
              {loadingSubscription ? 'Loading...' : (
                isInTrialPeriod() ? (
                  `${calculateTrialDaysLeft()} days trial remaining`
                ) : (
                  companySubscription ? 'View Subscription' : 'Subscription Plans'
                )
              )}
            </button>
          )}
          
        </div>

        <button
          className="btn btn-blue float-end menu-toggle d-lg-none"
          data-bs-target="#sidebar"
          data-bs-toggle="collapse"
        >
          <i className="fa fa-bars"></i>
        </button>
        <nav className="collapse d-lg-block" id="sidebar" style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
          <ul className="list-unstyled mb-0">
            {Routers?.map((props, i) => {
              if (props?.hidden || (props.subname === "company" && resolvedIsCompany) || (props?.superAdminOnly && data?.is_company)) {
                return null;
              } else if (!isMenuItemVisibleForIncompleteProfile(props)) {
                return null;
              } else {
                if (resolvedAdminType === "super admin") {
                  // Check if this menu item should be locked due to subscription
                  // Class (Organization Setup) and Teacher menu items should always be accessible
                  const isLocked = resolvedIsCompany && !hasActiveSubscription() && props.subname !== "dashboard" && props.subname !== "class" && props.subname !== "teacher";
                  
                  return (
                    <li key={i}>
                    <div className="menu-item" onClick={() => {
                      if (isLocked) {
                        handleLockedMenuClick('subscription')();
                        return;
                      }
                      toggleMenu(i);
                      handleSidebarNavigation();
                    }}>
                      <Link
                            to={isLocked ? "#" : (props.subname === "dashboard" ? "/dashboard" : props.subname === "company" ? "/company" : "#")} // Conditional path
                        className={props.subPath.some(path => window.location.pathname.split('/').filter(Boolean)[0].includes(path)) ? "active" : ""}
                        onClick={(e) => {
                          if (isLocked) {
                            e.preventDefault();
                            handleLockedMenuClick('subscription')();
                            return;
                          }
                          handleSidebarNavigation();
                        }}
                      >
                        <div className="d-flex align-items-center">
                          <img
                            src={props.inactiveImage}
                            className="img-fluid sidebar-icon inactive-icon me-2"
                            alt=""
                          />
                          <img
                            src={props.activeImage}
                            className="img-fluid sidebar-icon active-icon me-2"
                            alt=""
                          />
                        <span>{props.name}</span>
                        {isLocked && <i className="fa fa-lock ms-2" style={{fontSize: '14px', opacity: 0.9, color:"#D9B60D"}}></i>}
                        </div>
                      </Link>
                    </div>
                    {props.subElements && props.subElements.length > 0 && (
                      <ul className={`list-unstyled ms-0  mb-0 submenu ${openMenu === i || props.subPath.some(path => window.location.pathname.split('/').filter(Boolean)[0] == path) ? "open" : ""}`}>
                      {filterSubElementsForIncompleteProfile(props.subElements, props.subname).map((subElement, j) => {
                        const lockStatus = isMenuItemLocked(subElement);
                        const nestedKey = `${i}-${j}`;
                        const hasChildren = subElement.subElements && subElement.subElements.length > 0;
                        const isNestedActive = subElement.subPath?.some(path => window.location.pathname.split('/').filter(Boolean)[0] == path);
                        if (
                          subElement.path === "/terms-and-conditions" &&
                          !isPlatformSuperAdmin
                        ) {
                          return null;
                        }
                        return !subElement.hidden && subElement.subname !== "earning" ? (
                          <li key={j} className={`submenu-item`}>
                            <Link
                              to={lockStatus.locked ? "#" : subElement.path}
                              className={location.pathname.includes(subElement.subpath) ? "active" : ""}
                              onClick={(e) => {
                                if (lockStatus.locked) {
                                  return handleLockedMenuClick(lockStatus.reason)(e);
                                }
                                if (!hasChildren) {
                                  handleSidebarNavigation();
                                }
                                if (hasChildren) {
                                  e.preventDefault();
                                  toggleSubMenu(nestedKey);
                                }
                              }}
                            >
                              <p className={subElement.subPath.some(path => window.location.pathname.split('/').filter(Boolean)[0].includes(path)) ? "active" : ""}>
                                {subElement.name}
                                {lockStatus.locked && <i className="fa fa-lock ms-2" style={{fontSize: '14px', opacity: 0.9, color:"#D9B60D"}}></i>}
                              </p>
                            </Link>
                            {subElement.subElements && subElement.subElements.length > 0 && (
                              <ul className={`list-unstyled ms-3 mb-0 submenu ${openSubMenu?.[nestedKey] || isNestedActive ? "open" : ""}`}>
                                {subElement.subElements.map((child, k) => (
                                  !child.hidden ? (
                                    <li key={k} className="submenu-item">
                                      <Link
                                        to={child.path}
                                        className={child.subPath?.some(path => window.location.pathname.split('/').filter(Boolean)[0] == path) ? "active" : ""}
                                        onClick={() => handleSidebarNavigation()}
                                      >
                                        <p className={child.subPath?.some(path => window.location.pathname.split('/').filter(Boolean)[0].includes(path)) ? "active" : ""}>
                                          {child.name}
                                        </p>
                                      </Link>
                                    </li>
                                  ) : null
                                ))}
                              </ul>
                            )}
                          </li>
                        ) : null;
                      })}
                    </ul>
                    )}
                  </li>
                  );
                } else {
                  // Check if company has active subscription
                  // Class (Organization Setup) and Teacher menu items should always be accessible
                  const isLocked = resolvedIsCompany && !hasActiveSubscription() && props.subname !== "dashboard" && props.subname !== "class" && props.subname !== "teacher";
                  
                  for (const key in resolvedModules) {
                    if (Object.hasOwnProperty.call(resolvedModules, key)) {
                      const element = resolvedModules[key];
                      if ( (key.includes(props.subname) && element === true) ||
                      (props.subElements?.some(sub => key.includes(sub.subname)) && element === true) ) {
                        return (
                          <li key={i}>
                          <div className="menu-item" onClick={() => {
                            if (isLocked) {
                              handleLockedMenuClick('subscription')();
                              return;
                            }
                            toggleMenu(i);
                            handleSidebarNavigation();
                          }}>
                            <Link
                                  to={isLocked ? "#" : (props.subname === "dashboard" ? "/dashboard" : props.subname === "company" ? "/company" : "#")} // Conditional path
                              className={props.subPath.some(path => window.location.pathname.split('/').filter(Boolean)[0].includes(path)) ? "active" : ""}
                              onClick={(e) => {
                                if (isLocked) {
                                  e.preventDefault();
                                  handleLockedMenuClick('subscription')();
                                  return;
                                }
                                handleSidebarNavigation();
                              }}
                            >
                              <div className="d-flex align-items-center">
                                <img
                                  src={props.inactiveImage}
                                  className="img-fluid sidebar-icon inactive-icon me-2"
                                  alt=""
                                />
                                <img
                                  src={props.activeImage}
                                  className="img-fluid sidebar-icon active-icon me-2"
                                  alt=""
                                />
                              <span>{props.name}</span>
                              {isLocked && <i className="fa fa-lock ms-2" style={{fontSize: '14px', opacity: 0.9, color:"#D9B60D"}}></i>}
                              </div>
                            </Link>
                          </div>
                          {props.subElements && props.subElements.length > 0 && (
                            <ul
                              className={`list-unstyled ms-0 mb-0 submenu ${
                                openMenu === i ||
                                props.subPath.some(
                                  path =>
                                    window.location.pathname.split("/").filter(Boolean)[0] == path
                                )
                                  ? "open"
                                  : ""
                              }`}
                            >
                              {filterSubElementsForIncompleteProfile(props.subElements, props.subname).map((subElement, j) => {
                                const lockStatus = isMenuItemLocked(subElement);
                                const nestedKey = `${i}-${j}`;
                                const hasChildren = subElement.subElements && subElement.subElements.length > 0;
                                const isNestedActive = subElement.subPath?.some(path => window.location.pathname.split('/').filter(Boolean)[0] == path);
                                return resolvedModules?.[subElement.subname] === true && element === true && subElement.subname !== "finance" && subElement.subname !== "fee-settings" ? (
                                  <li key={j} className="submenu-item">
                                    <Link
                                      to={lockStatus.locked ? "#" : subElement.path}
                                      className={isNestedActive ? "active" : ""}
                                      onClick={(e) => {
                                        if (lockStatus.locked) {
                                          return handleLockedMenuClick(lockStatus.reason)(e);
                                        }
                                        if (!hasChildren) {
                                          handleSidebarNavigation();
                                        }
                                        if (hasChildren) {
                                          e.preventDefault();
                                          toggleSubMenu(nestedKey);
                                        }
                                      }}
                                    >
                                      <p
                                        className={isNestedActive ? "active" : ""}
                                      >
                                        {subElement.name}
                                        {lockStatus.locked && <i className="fa fa-lock ms-2" style={{fontSize: '12px', opacity: 0.7}}></i>}
                                      </p>
                                    </Link>
                                    {subElement.subElements && subElement.subElements.length > 0 && (
                                      <ul className={`list-unstyled ms-3 mb-0 submenu ${openSubMenu?.[nestedKey] || isNestedActive ? "open" : ""}`}>
                                        {subElement.subElements.map((child, k) => (
                                          !child.hidden ? (
                                            <li key={k} className="submenu-item">
                                              <Link
                                                to={child.path}
                                                className={child.subPath?.some(path => window.location.pathname.split('/').filter(Boolean)[0] == path) ? "active" : ""}
                                                onClick={() => handleSidebarNavigation()}
                                              >
                                                <p className={child.subPath?.some(path => window.location.pathname.split('/').filter(Boolean)[0].includes(path)) ? "active" : ""}>
                                                  {child.name}
                                                </p>
                                              </Link>
                                            </li>
                                          ) : null
                                        ))}
                                      </ul>
                                    )}
                                  </li>
                                ) : null;
                              })}
                            </ul>
                          )}

                        </li>
                        );
                      }
                    }
                  }
                }
              }
            })}
            <li className="mt-1 d-none">
              <Link className="dropdown-item" to="/change-password">
                <span>change password</span>
              </Link>
            </li>
            {data?.modules?.settings && (
              <li>
                <Link className="dropdown-item" to="/settings" onClick={() => handleSidebarNavigation()}>
                  <span>
                    <i className="fa fa-gear" aria-hidden="true"></i> Settings
                  </span>
                </Link>
              </li>
            )}

            <li style={{marginTop: -20}}>
              <Link
                className="dropdown-item"
                to={() => {
                  return false;
                }}
                onClick={(e) => {
                  logout(e);
                }}
              >
                <span>
                  <i className="fa fa-sign-out" aria-hidden="true"></i> logout
                </span>
              </Link>
            </li>

            {/* <li className="">
              <a
                href="#setting"
                className="show-collape-border"
                data-bs-toggle="collapse"
                aria-expanded="false"
                aria-controls="setting"
              >
                <div>
                  <img
                    src="assets/images/Settings.png"
                    className="img-fluid sidebar-icon inactive-icon"
                    alt=""
                  />
                  <img
                    src="assets/images/Settings-selected.png"
                    className="img-fluid sidebar-icon active-icon"
                    alt=""
                  />
                </div>
                <span>setting </span>
              </a>
              <div className="collapse collapse-border" id="setting">
               
              </div>
            </li> */}
          </ul>
        </nav>
      </div>
      <SubscriptionPlansModal
          show={showSubscriptionModal}
          onClose={() => setShowSubscriptionModal(false)}
          companySubscription={companySubscription}
        />
      <OnboardingModal
        isOpen={showOnboardingModal}
        onClose={handleOnboardingModalClose}
        companyData={data}
        authState={authState}
        profileCompletionData={profileCompletionData}
      />
      <OnboardingCompleteModal
        isOpen={showOnboardingCompleteModal}
        onClose={handleOnboardingCompleteModalClose}
        onStartTrial={handleStartTrial}
        onPurchaseSubscription={handlePurchaseSubscription}
        isInTrial={isInTrialPeriod()}
        trialDaysLeft={calculateTrialDaysLeft()}
        isTrialExpired={data?.trial_end && new Date() > new Date(data.trial_end)}
        companyId={id}
        hasBespokeEnquiry={data?.has_bespoke_enquiry == 1}
      />
    </div>
  );
}

export default Sidebar;